import * as React from 'react';
import styled from 'styled-components';
import { themes } from 'kb-shared';

const Container = styled.div`
  display: flex;
  margin-left: 20px;
`;

const TextRowContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: white;
`;

const TextRowContainerMargin = styled(TextRowContainer)`
  padding-left: 20px;
`;

const ROW_HEIGHT = 48;

interface ClickableProps {
  clickable?: boolean;
}

const TextRow = styled.div`
  display: flex;
  align-items: center;
  height: ${`${ROW_HEIGHT}px`};
  ${({ clickable }: ClickableProps) => `
    cursor: ${clickable ? 'pointer' : 'auto'}
  `}
`;

interface SelectedProps {
  selected?: boolean;
}

const Text = styled.div`
  text-align: left;
  ${themes.fonts.FoundersGrotesk};

  ${({ selected }: SelectedProps) => `
    color: ${selected ? themes.colors.KBNight : themes.colors.KBLightBlueGrey};
    font-weight: ${selected ? 'bolder' : 'normal'};
    transition: all 400ms ease 0s;
  `}
`;

type Props = {
  steps: string[];
  selectedStep: number;
  onSelectStep: (index: number) => void;
};

export default class StepTracker extends React.Component<Props> {
  static defaultProps: Props = {
    steps: [],
    selectedStep: 0,
    onSelectStep: () => {}
  };

  renderSteps() {
    return (
      <TextRowContainerMargin>
        {this.props.steps.map((step: string, index: number) => {
          const clickable = index < this.props.selectedStep;
          return (
            <TextRow
              clickable={clickable}
              key={step}
              onClick={() => {
                // Clicking is only permitted if it's a previous/alreeady passed step
                if (clickable) {
                  this.props.onSelectStep(index);
                }
              }}
            >
              <Text selected={index === this.props.selectedStep}>{step}</Text>
            </TextRow>
          );
        })}
      </TextRowContainerMargin>
    );
  }

  render() {
    return (
      <Container>
        <StepIndicator currentIndex={this.props.selectedStep} />
        {this.renderSteps()}
      </Container>
    );
  }
}

const StepperBackground = styled.div`
  width: 4px;
  background-color: ${themes.colors.KBBeige};
  flex: 1;
`;

interface CurrentIndexProps {
  currentIndex: number;
}

const Stepper = styled.div`
  position: absolute;
  height: ${`${ROW_HEIGHT}px`};
  background-color: ${themes.colors.KBYellow};
  width: 4px;
  transition: all 400ms ease 0s;
  top: ${(props: CurrentIndexProps) => `${props.currentIndex * ROW_HEIGHT}px`};
`;

type StepperProps = {
  currentIndex: number;
};

const StepIndicator = (props: StepperProps) => {
  return (
    <TextRowContainer>
      <Stepper currentIndex={props.currentIndex} />
      <StepperBackground />
    </TextRowContainer>
  );
};
